import { common } from 'ui-lib/color-pallete';
import { alpha } from '@mui/material/styles';
import { CHART_THEME_MODE } from '../const';
import { ChartTheme } from './types';
import { createChartColorGroupPaletteFactory } from './utils';

const LIGHT_FILL_SEMI_OPACITY = 0.3;
const LIGHT_TONAL_BACKGROUND_OPACITY = 0.15;

const createLightChartColorGroupPalette = createChartColorGroupPaletteFactory(LIGHT_FILL_SEMI_OPACITY, LIGHT_TONAL_BACKGROUND_OPACITY);

export const lightChartTheme: ChartTheme = {
  mode: CHART_THEME_MODE.LIGHT,
  palette: {
    general: {
      axis: '#7A87B8',
      grid: '#DEE1ED',
      labels: alpha('#364163', 0.65),
      gridHover: '#9CA7C9',
      fillHover: alpha(common.black, 0.2),
      fillBackground: '#DEE1ED',
      scrollBar: common.white,
    },
    primary: createLightChartColorGroupPalette({
      fillDark2: '#3B3FBA',
      fillDark1: '#5A5EE7',
      fill: '#7E82EC',
      fillLight1: '#BABCF7',
      fillLight2: '#D9DAFC',
    }),
    secondary: createLightChartColorGroupPalette({
      fillDark2: '#343742',
      fillDark1: '#4E556A',
      fill: '#6C7693',
      fillLight1: '#9DA4B8',
      fillLight2: '#CDD1DA',
    }),
    red: createLightChartColorGroupPalette({
      fillDark2: '#A3292D',
      fillDark1: '#E44449',
      fill: '#F57F83',
      fillLight1: '#FBBBBD',
      fillLight2: '#FDE3E4',
    }),
    yellow: createLightChartColorGroupPalette({
      fillDark2: '#9A8209',
      fillDark1: '#BEA213',
      fill: '#DFBF20',
      fillLight1: '#F6DC5A',
      fillLight2: '#F4E9B3',
    }),
    green: createLightChartColorGroupPalette({
      fillDark2: '#2A6916',
      fillDark1: '#449F28',
      fill: '#5DC83C',
      fillLight1: '#89DC6F',
      fillLight2: '#C7F2BA',
    }),
    blue: createLightChartColorGroupPalette({
      fillDark2: '#1A5775',
      fillDark1: '#2176A1',
      fill: '#279AD3',
      fillLight1: '#8DC6E2',
      fillLight2: '#C5E2F1',
    }),
    purple: createLightChartColorGroupPalette({
      fillDark2: '#5D2191',
      fillDark1: '#8A37D2',
      fill: '#A766E1',
      fillLight1: '#BF95E4',
      fillLight2: '#DCC5F1',
    }),
    orange: createLightChartColorGroupPalette({
      fillDark2: '#75411A',
      fillDark1: '#A15821',
      fill: '#D37127',
      fillLight1: '#E2B28D',
      fillLight2: '#F1D8C5',
    }),
    brand: createLightChartColorGroupPalette({
      fillDark2: '#1A754A',
      fillDark1: '#21A165',
      fill: '#27D383',
      fillLight1: '#8DE2BA',
      fillLight2: '#C5F1DC',
    }),
  },
};
